import { useEffect, useState } from "react"
import earth from "../resources/images/earth.png"
import github from "../resources/images/github.png"
import { CellularAutomata1D } from "./cellular-automata/1d/cellularAutomata1D"
import { AutomataSelector } from "./cellular-automata/automata-selector"
import * as MIDI from "./performers/audio/MIDI"
import CellularAutomataSketch from "./sketch/sketch"

export default function HumanMusic() {
   const [started, setStarted] = useState(false)
   const [loaded, setLoaded] = useState(false)
   const [automata, setAutomata] = useState<CellularAutomata1D | null>(null)

   useEffect(() => {
      if (!loaded) {
         MIDI.loadMidi(() => setLoaded(true))
      }
   }, [loaded])

   async function start() {
      await MIDI.resumeAudioContext()
      MIDI.start()
      setStarted(true)
      randomiseAutomata()
   }

   function randomiseAutomata() {
      const selector = new AutomataSelector()
      setAutomata(selector.randomSelection())
   }

   return (
      <div style={{ 
         textAlign: "center", 
         background: "#141414", 
         minHeight: "100vh",
         color: "white",
         fontFamily: "Arial, sans-serif"
      }}>
         <div style={{ padding: "20px" }}>
            <img src={earth} alt="Earth" style={{ width: "80px" }} />
            <h1 style={{ color: "#b12525", margin: "10px 0" }}>Human Music</h1>
            <p style={{ margin: "5px 0" }}>by Earth Radio</p>
         </div>

         <div style={{ 
            width: "400px", 
            height: "400px", 
            margin: "20px auto",
            border: "2px solid white",
            background: "#090909"
         }}>
            {loaded && automata ? (
               <CellularAutomataSketch automata={automata} />
            ) : (
               <div style={{ paddingTop: "180px", color: "#666" }}>Loading...</div>
            )}
         </div>

         <div style={{ marginTop: "20px" }}>
            {started ? (
               <button 
                  onClick={randomiseAutomata}
                  style={{
                     padding: "10px 30px",
                     fontSize: "16px",
                     background: "#666",
                     color: "white",
                     border: "none",
                     cursor: "pointer"
                  }}
               >
                  Randomise
               </button>
            ) : (
               <button 
                  onClick={start}
                  disabled={!loaded}
                  style={{
                     padding: "10px 30px",
                     fontSize: "16px",
                     background: loaded ? "#666" : "#333",
                     color: "white",
                     border: "none",
                     cursor: loaded ? "pointer" : "not-allowed"
                  }}
               >
                  {loaded ? "Start" : "Loading..."}
               </button>
            )}
         </div>

         <div style={{ marginTop: "30px" }}>
            <a href="https://github.com/juankysoriano/human-music">
               <img src={github} alt="GitHub" style={{ width: "30px", filter: "invert(1)" }} />
            </a>
            <p style={{ fontSize: "14px", marginTop: "10px" }}>A mi padre ♥</p>
         </div>
      </div>
   )
}